import { usePut } from '../../HttpClient';
import { useMutationWithErrorHandling } from '../../../hooks/UseMutationWithErrorHandling';

export function useUpdateAccountTreatment() {
  const put = usePut(true, "ams");
  const updateAccountTreatment = (accountId: string, treatmentId: string,  accountTreatmentEffectiveDate?: Date, accountTreatmentExpiryDate?: Date, expiresInNumberOfBillingPeriods?: number) => {
    return put(`/api/proxy/ams/account-service/account/${accountId}/update-treatment`, {
        accountTreatmentId: treatmentId,
        accountTreatmentEffectiveDate,
        accountTreatmentExpiryDate,
        expiresInNumberOfBillingPeriods
    });
  };

  return useMutationWithErrorHandling({
    mutationFn: ({ accountId, treatmentId, accountTreatmentEffectiveDate,  accountTreatmentExpiryDate, expiresInNumberOfBillingPeriods }: { accountId: string, treatmentId: string,  accountTreatmentEffectiveDate?: Date, accountTreatmentExpiryDate?: Date, expiresInNumberOfBillingPeriods?: number }) =>
      updateAccountTreatment(accountId, treatmentId, accountTreatmentEffectiveDate, accountTreatmentExpiryDate, expiresInNumberOfBillingPeriods),
  });
}
